class ZenachStickyBuy extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.button = this.querySelector('[data-zenach-buy]');
    this.caption = this.querySelector('[data-zenach-selection]');
    this.main = document.querySelector('.product-information');
    if (!this.main) return;
    const signal = this.abort.signal;
    this.sync = () => {
      const native = this.main.querySelector('product-form-component button[type="submit"]');
      const form = this.main.querySelector('product-form-component form');
      if (!native || !form) { this.hidden = true; return; }
      this.native = native;
      this.button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.button.disabled ? native.textContent.trim() : this.dataset.addLabel;
      const chosen = [...this.main.querySelectorAll('variant-picker input[type="radio"]:checked')].map(i => i.value).join(' / ');
      this.caption.textContent = chosen;
      const pastButton = native.getBoundingClientRect().bottom < 0;
      const drawerOpen = !!document.querySelector('dialog[open], #Details-menu-drawer-container[open]');
      this.hidden = !window.matchMedia('(max-width: 749px)').matches || !pastButton || drawerOpen;
      document.body.classList.toggle('zenach-sticky-visible', !this.hidden);
    };
    this.button.addEventListener('click', () => {
      this.sync();
      if (this.native && !this.button.disabled) this.native.click();
    }, { signal });
    let scheduled = false;
    const schedule = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; this.sync(); }); };
    document.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { signal });
    document.addEventListener('variant:selected', () => { this.button.disabled = true; }, { signal });
    document.addEventListener('variant:update', schedule, { signal });
    document.addEventListener('cart:update', schedule, { signal });
    document.addEventListener('change', schedule, { signal });
    this.observer = new MutationObserver(schedule);
    this.observer.observe(this.main, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled'] });
    this.dialogObserver = new MutationObserver(schedule);
    this.dialogObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
    this.sync();
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.dialogObserver?.disconnect(); document.body.classList.remove('zenach-sticky-visible'); }
}
if (!customElements.get('zenach-sticky-buy')) customElements.define('zenach-sticky-buy', ZenachStickyBuy);
